import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { environment } from './../../environments/environment';

import { map } from 'rxjs/operators';
interface Admin {
      _id : string,
    permissions: any,
    role: string
}


@Injectable({ providedIn: 'root' })
export class LoginService {
    baseUrl: string = environment.BASE_URL;
    userDetail: any = {};
    private currentUserSubject: BehaviorSubject<Object>;
    public currentUser: Observable<Object>;
    //userSubject: BehaviorSubject<Admin>;
    public userSubject = new BehaviorSubject(this.userDetail);
    public userSubjectResponse = this.userSubject.asObservable()

    constructor(
        private http: HttpClient,
        private router: Router,
        private httpClient: HttpClient,
        ) {
        this.currentUserSubject = new BehaviorSubject<Object>(localStorage.getItem('currentUser'));
        this.currentUser = this.currentUserSubject.asObservable();

    }

    public get currentUserValue() {
        return this.currentUserSubject.value;
    }

    authToken() {
        const headers = new HttpHeaders({ 'Authorization': `Bearer ${localStorage.getItem('token')}` });
        return { headers: headers };
    }

    getHeader() {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Accept-Language': 'en-US'
        });
        return { headers: headers };
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
        this.userDetail = {};
    }

    login(obj) {
      return this.http.post<any>(`${environment.apiUrl}/admin/login`,obj)
          .pipe(map(result => {
              // login successful if there's a jwt token in the response
              if (result && result.data) {
                  // store user details and jwt token in local storage to keep user logged in between page refreshes
                  localStorage.setItem('currentUser', result.data.token);
                  this.currentUserSubject.next(result.data.token);
              }
              return result;
          }));
    }
}
